export const enum Vendors {
  WEST_ELM = 1,
  POTTERY_BARN = 2,
  WILLIAMS_SONOMA = 3,
  OVERSTOCK = 33,
  REJUVENATION = 72,
  POTTERY_BARN_TEEN = 84,
  POTTERY_BARN_KIDS = 88,
  INTERIOR_DEFINE = 91,
  MARK_AND_GRAHAM = 330,
  PBTEEN = 1392
}

// Willians-Sonoma vendors
const WSIVendorsList = [
  Vendors.WEST_ELM,
  Vendors.POTTERY_BARN,
  Vendors.WILLIAMS_SONOMA,
  Vendors.REJUVENATION,
  Vendors.POTTERY_BARN_TEEN,
  Vendors.POTTERY_BARN_KIDS,
  Vendors.MARK_AND_GRAHAM,
  Vendors.PBTEEN
];

export const NoIndexVendorsList = WSIVendorsList;
export const OnlyAuthedAccessVendorsList = WSIVendorsList;

export const isOverstockVendor = (vendorId: number): boolean => {
  return vendorId === Vendors.OVERSTOCK;
};
